import http from "../../http-common";
/* eslint-disable */
class AksesKontrolService {
  aksesKontrolAll(roleId) {
    return http.get("/role/akses-kontrol/all?role_id=" + roleId, {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  update(data) {
    return http.post(`/role/akses-kontrol`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }
}

export default new AksesKontrolService();
